import script from "./CurrenciesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrenciesList.vue?vue&type=script&setup=true&lang=ts"

import "./CurrenciesList.vue?vue&type=style&index=0&id=99413692&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99413692"]])

export default __exports__